import type { ElementChipSelection } from './elementChipsTypes';

export const ELEMENT_CHIP_SELECT = 'ELEMENT_CHIP_SELECT';

/**
 * Selects a chip in the generic element chips state.
 */
export const selectElementChip = (selection: ElementChipSelection) => ({
    type: ELEMENT_CHIP_SELECT,
    selection,
});

/**
 * Clears the generic element chip selection.
 */
export const deselectElementChip = () => ({
    type: ELEMENT_CHIP_SELECT,
    selection: null,
});

export type ElementChipsAction = ReturnType<typeof selectElementChip> | ReturnType<typeof deselectElementChip>;
